"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function _export(target, all) {
  for (var name in all) Object.defineProperty(target, name, {
    enumerable: true,
    get: Object.getOwnPropertyDescriptor(all, name).get
  });
}
_export(exports, {
  get BLOCKS() {
    return _blocks.BLOCKS;
  },
  get EMPTY_DOCUMENT() {
    return _emptyDocument.EMPTY_DOCUMENT;
  },
  get INLINES() {
    return _inlines.INLINES;
  },
  get MARKS() {
    return _marks.MARKS;
  },
  get helpers() {
    return _helpers;
  },
  get validateRichTextDocument() {
    return _index.validateRichTextDocument;
  }
});
var _blocks = require("./blocks.js");
var _inlines = require("./inlines.js");
var _marks = require("./marks.js");
_export_star(require("./schemaConstraints.js"), exports);
_export_star(require("./types.js"), exports);
_export_star(require("./nodeTypes.js"), exports);
var _emptyDocument = require("./emptyDocument.js");
var _helpers = /*#__PURE__*/_interop_require_wildcard(require("./helpers.js"));
var _index = require("./validator/index.js");
function _export_star(from, to) {
  Object.keys(from).forEach(function (k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
      Object.defineProperty(to, k, {
        enumerable: true,
        get: function () {
          return from[k];
        }
      });
    }
  });
  return from;
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {
    __proto__: null
  };
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}